import * as React from 'react';
import * as ReqType from '../../../types/ServerRequests';
import { AdresseForm } from '../../genericComponents/AdresseForm/AdresseForm';
import { LoaderButton } from '../../genericComponents/Button/LoaderButton';
import { EventService } from '../../../services/EventService';
import { EventDetailForm } from './EventDetailForm';
import { DatetimeForm } from '../../genericComponents/Date/DatetimeForm';
import LoginServices from '../../../services/LoginServices';
import { UserRole } from '../../../types/UserRole';

/**
 * interface Props (le parametre de la classe)
 */
export interface Props {
    /**
     * information: l'évènement
     */
    information: ReqType.Event;

    /**
     * le changenement d'un évènement
     * @param {Event} e
     */
    changeEvent: (e: ReqType.Event) => void;
}

interface State {
    editable: boolean;
}

/**
 * Ce composant permet d'afficher les informations d'un événement.
 * Il prend en paramétre un event et une méthode pour changer l'état du composant.
 * Le composant ne fait appel à aucun service.
 */
export class InfoEvent extends React.Component {
    /** le props: l'etat externe */
    props: Props;
    /** le state: l'etat interne */
    state: State;
    /** le backupEvent: le sauvegard de l'evenement */
    backupEvent: ReqType.Event;

    /**
     * construit le InfoEvent
     * @param {Props} props
     */
    constructor(props: Props) {
        super(props);
        this.state = {
            editable: false,
        };
    }

    /**
     * le rendu de la InfoEvent
     * @returns {JSX.element}
     */
    render() {
        const role = LoginServices.getInstance().getType();
        return (
            <div className="card card-default">
                <div className="row card-header col-12" style={{ marginLeft: '1px' }}>
                    <div className="col-9"><h4 className="text-white"><strong>Informations générales</strong></h4></div>
                    <div
                        className="col-3"
                        style={{ textAlign: 'right' }}
                    >
                    {
                        role === UserRole.ADMIN.toString() ?
                            (
                                <button
                                    className="btn btn-outline-light"
                                    onClick={
                                        () => {
                                            this.backupEvent = EventService
                                                .getInstance()
                                                .duplicateEvent(this.props.information);
                                            this.setState({ editable: true });
                                        }
                                    }
                                >
                                    <i className="fas fa-edit" />
                                </button>
                            ) : undefined
                    }
                    </div>
                </div>

                <div className="card-body">
                    <this.DisplayInformation />
                </div>

                <div className="card-footer" style={this.state.editable ? {} : { display: 'none' }}>
                    <div className="container-fluid justify-content-end" style={{ display: 'flex' }}>
                        <button
                            className="btn btn-outline-danger btn-lg"
                            onClick={
                                () => {
                                    this.props.changeEvent(this.backupEvent);
                                    this.setState({ editable: false });
                                }
                            }

                        >
                            Annuler
                        </button>
                        <LoaderButton
                            className="btn btn-lg"
                            style={{ marginLeft: '20px' }}
                            onClick={
                                () => {
                                    return (this.sendServer().then(
                                        () => {
                                            this.setState({ editable: false });
                                        }
                                    ));
                                }
                            }
                            confirmation={true}
                            modalTitle="Changement des informations du profil"
                            modalBody="Etes vous certain de vouloir changer ces information ?"
                        >
                            Valider
                        </LoaderButton>
                    </div>
                </div>
            </div>
        );
    }

    /**
     * affichage du formulaire event form
     * @returns {JSX.element}
     * @constructor
     */
    private DisplayEventForm() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.props.information === null) {
            return (undefined);
        } else {
            return (
                <li className={liClass}>
                    <EventDetailForm
                        event={this.props.information}
                        disabled={!this.state.editable}
                        setEvent={
                            (event: ReqType.Event) => {
                                this.props.changeEvent(event);
                            }
                        }
                    />
                </li >
            );
        }
    }

    /**
     * affichage de la date de l'evènement
     * @returns {JSX.element}
     * @constructor
     */
    private DisplayDateForm() {
        const liClass = 'list-group-item text-black bg-white';
        if (this.props.information === null) {
            return (undefined);
        } else {
            return (
                <li className={liClass}>
                    <div className="row col-12 form-group">
                        <label
                            style={{fontSize: '20px', width: '4.4cm', marginRight: '13px'}}
                            className="text-right col-form-input"
                        >
                            Date de début :
                        </label>
                            <DatetimeForm
                                date={this.props.information.date_heure_debut}
                                disabled={!this.state.editable}
                                setDate={
                                    (d: Date) => {
                                        var newEvent = EventService.getInstance()
                                            .duplicateEvent(this.props.information);
                                        newEvent.date_heure_debut = d;
                                        this.props.changeEvent(newEvent);
                                    }
                                }
                                hour={true}
                            />
                    </div>
                    <div className="row col-12 form-group">
                        <label
                            style={{fontSize: '20px', width: '4.4cm', marginRight: '13px'}}
                            className="text-right col-form-input"
                        >
                            Date de fin :
                        </label>
                        <DatetimeForm
                            date={this.props.information.date_heure_fin}
                            disabled={!this.state.editable}
                            setDate={
                                (d: Date) => {
                                    var newEvent = EventService.getInstance().duplicateEvent(this.props.information);
                                    newEvent.date_heure_fin = d;
                                    this.props.changeEvent(newEvent);
                                }
                            }
                            hour={true}
                        />
                    </div>
                </li >
            );
        }
    }

    /**
     * affichage du Cours Form
     * @returns {JSX.element}
     * @constructor
     */
    private EventTypeCoursForm() {
        const liClass = 'list-group-item list-group-item-wight';
        if (this.props.information === null || this.props.information.cours === null) {
            return (undefined);
        } else {
            return (
                <li className={liClass}>
                    <div className="row form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm', marginTop: '8px'}}
                            className="text-right col-form-input"
                        >
                            Cours associé :
                        </label>
                        <p className="form-control-lg col-sm-6">
                            {this.props.information.cours.details}
                        </p>
                    </div>
                </li >
            );
        }
    }

    /**
     * affichage du type de formulaire
     * @returns {JSX.element}
     * @constructor
     */
    private DisplayTypeForm() {
        const liClass = 'list-group-item list-group-item-wight';
        if (this.props.information === null) {
            return (undefined);
        } else {
            return (
                <li className={liClass}>
                    <div className="row form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm', marginTop: '8px'}}
                            className="text-right col-form-input"
                        >Type d'événement :
                        </label>
                        <p className="form-control-lg col-sm-6">
                            {this.props.information.type_event.nom_type}
                        </p>
                    </div>

                </li >
            );
        }
    }

    /**
     * affichage de l'adresse
     * @returns {JSX.element}
     * @constructor
     */
    private DisplayAdresse() {
        const liClass = 'list-group-item list-group-item-wight';
        if (this.props.information === null) {
            return (undefined);
        } else {
            return (
                <li className={liClass}>
                    <div className="row form-group">
                        <label
                            style={{fontSize: '20px', width: '4.8cm', marginTop: '8px'}}
                            className="text-right col-form-input"
                        >Adresse :
                        </label>
                        <div className="form-control-lg col-sm-6">
                            <AdresseForm
                                adresse={this.props.information.adresse}
                                disabled={!this.state.editable}
                                setAdresse={
                                    (adresse: ReqType.Adresse) => {
                                        if (this.props.information !== null) {
                                            var newEvent = EventService.getInstance().
                                            duplicateEvent(this.props.information);
                                            newEvent.adresse = adresse;
                                            this.props.changeEvent(newEvent);
                                        }
                                    }
                                }
                            />
                        </div>

                    </div>
                </li >
            );
        }
    }

    /**
     *  affichage des informations du titulaire du compte.
     * @returns {any}
     * @constructor
     */
    private DisplayInformation = () => {
        return (
            <div className="col-12">
                <ul className="list-group">
                    {this.DisplayEventForm()}
                    {this.DisplayDateForm()}
                    {this.DisplayTypeForm()}
                    {this.EventTypeCoursForm()}
                    {this.DisplayAdresse()}
                </ul>
            </div>
        );
    }

    // Mise en ligne
    /**
     * appelle du service qui gère l'évènement
     * @returns {Promise<void>}
     */
    private sendServer(): Promise<void> {
        return (
            EventService.getInstance().editEvent(this.props.information, this.backupEvent).then(
                (resp: ReqType.Event) => {
                    this.props.changeEvent(resp);
                    return;
                }
            )
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/EventPage/internalComponents/InfoEvent.tsx